import { Link } from "react-router";
import { LegalPage } from "@/components/auth/LegalPage";
import { BRAND } from "@/lib/brand";

const EFFECTIVE = "2026년 11월 1일(예정)";

/** 개인정보처리방침 , 초안(법무 검토 전). 처리자는 운영사(주식회사 볼트에이아이) */
export function PrivacyPage() {
  return (
    <LegalPage title="개인정보처리방침" effective={EFFECTIVE}>
      <p>
        주식회사 {BRAND.DEVELOPER}(이하 "회사")는 {BRAND.ORG}의 「{BRAND.TITLE} 프로그램」(이하 "서비스")을 운영하면서 「개인정보 보호법」에 따라 이용자의 개인정보를 보호하고 관련 고충을 신속하게 처리하기 위하여 다음과 같이 개인정보처리방침을 둡니다.
      </p>

      <h2>1. 개인정보의 처리 목적</h2>
      <ul>
        <li><b>회원 가입 및 관리</b>: 본인 식별, 계정 관리, 부정 이용 방지</li>
        <li><b>서비스 운영</b>: 시나리오 산정과 저장, 교육 과정 운영과 수료 관리, 일정 안내</li>
        <li><b>문의 대응</b>: 이용 문의와 오류 신고 처리</li>
        <li><b>교육 및 서비스 안내와 영업, 마케팅</b>(선택 동의 시): 수소 LCA 및 탄소 관련 교육 과정과 서비스 안내, 신규 과정 소개</li>
        <li><b>서비스 개선</b>: 이용 통계 분석. 통계는 개인을 식별할 수 없는 형태로 만듭니다.</li>
      </ul>

      <h2>2. 수집하는 개인정보의 항목과 방법</h2>
      <div className="legal-table">
        <table>
          <thead>
            <tr>
              <th>구분</th>
              <th>항목</th>
              <th>수집 방법</th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <th>필수</th>
              <td>이메일, 비밀번호(단방향 암호화 저장), 이름, 회사 또는 기관명, 연락처(휴대전화)</td>
              <td>가입 화면 입력</td>
            </tr>
            <tr>
              <th>선택</th>
              <td>부서, 직책</td>
              <td>가입 화면과 내 계정 입력</td>
            </tr>
            <tr>
              <th>동의 기록</th>
              <td>개인정보 수집 및 이용 동의 일시, 교육 및 서비스 안내(마케팅) 동의와 철회 일시</td>
              <td>가입 화면과 내 계정</td>
            </tr>
            <tr>
              <th>기업용 전환</th>
              <td>인증한 회사 이메일, 인증 일시, 인증 상태</td>
              <td>기업용 기능 전환 화면에서 인증번호 확인</td>
            </tr>
            <tr>
              <th>자동 수집</th>
              <td>마지막 로그인 일시, 로그인 세션 쿠키, 이용자가 저장한 시나리오</td>
              <td>서비스 이용 과정에서 생성</td>
            </tr>
          </tbody>
        </table>
      </div>

      <h2>3. 개인정보의 보유 및 이용기간</h2>
      <ul>
        <li><b>회원 정보와 기업용 전환 기록</b>: 회원 탈퇴 또는 교육 프로그램 종료 후 <b>3년</b>까지 보유하며, 기간이 지나면 지체 없이 파기합니다.</li>
        <li><b>마케팅 활용 동의 정보</b>: 동의를 철회하면 즉시 활용을 중지하고, 회원 정보와 함께 파기합니다.</li>
        <li><b>시나리오</b>: 회원 정보와 같은 기간 보유합니다. 이용자는 언제든 직접 삭제할 수 있습니다.</li>
        <li><b>법령에 따른 보존</b>: 관련 법령이 보존을 요구하는 기록(예: 「통신비밀보호법」에 따른 접속기록 3개월)은 그 기간 동안 보존합니다.</li>
      </ul>

      <h2>4. 개인정보의 제3자 제공</h2>
      <p>
        회사는 이용자의 개인정보를 제3자에게 제공하지 않습니다. 다만 이용자가 별도로 동의하거나 법령에 근거한 요청이 있는 경우는 예외입니다. 교육 주관기관인 {BRAND.ORG}에는 교육 운영 보고를 위하여 개인을 식별할 수 없는 통계(참여 인원, 기관별 인원)만 전달합니다. 수료 관리를 위하여 수료자 명단(이름, 회사, 이메일)의 제공이 필요한 경우 별도 동의를 받습니다. [법무 검토 항목]
      </p>

      <h2>5. 개인정보 처리의 위탁</h2>
      <p>회사는 서비스 운영을 위하여 다음과 같이 개인정보 처리를 위탁하고 있으며, 위탁계약에 개인정보 보호 관련 사항을 명시하고 수탁자를 감독합니다.</p>
      <div className="legal-table">
        <table>
          <thead>
            <tr>
              <th>수탁자</th>
              <th>위탁 업무</th>
              <th>보관 위치</th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <th>Microsoft Azure (Microsoft Corporation)</th>
              <td>클라우드 서버와 데이터베이스 호스팅, 백업</td>
              <td>대한민국 (Korea Central 리전)</td>
            </tr>
          </tbody>
        </table>
      </div>
      <p>개인정보는 국내 리전에 저장되며 국외로 이전하지 않습니다. 위탁 업체나 업무가 바뀌면 이 방침을 통해 공개합니다.</p>

      <h2>6. 정보주체의 권리와 행사 방법</h2>
      <ul>
        <li>이용자는 언제든 자신의 개인정보에 대하여 열람, 정정, 삭제, 처리정지를 요구하고 동의를 철회할 수 있습니다.</li>
        <li><b>정정 및 동의 철회</b>: 내 계정 화면에서 직접 고치거나 마케팅 동의를 해제할 수 있으며, 즉시 반영됩니다.</li>
        <li><b>삭제(탈퇴), 열람 및 처리정지</b>: 아래 개인정보 보호책임자에게 요청하면 지체 없이 처리합니다.</li>
        <li>권리 행사는 법정대리인이나 위임받은 사람을 통해서도 할 수 있으며, 법령이 정한 경우 제한될 수 있습니다.</li>
      </ul>

      <h2>7. 개인정보의 안전성 확보조치</h2>
      <ul>
        <li>비밀번호는 복원할 수 없는 단방향 암호화(해시)로 저장합니다.</li>
        <li>전송 구간은 HTTPS 로 암호화하고, 로그인 세션 쿠키에 HttpOnly와 Secure 속성을 적용합니다.</li>
        <li>관리자 권한은 필요한 최소 인원에게만 부여하고, 관리자의 자료 변경은 이력으로 남깁니다.</li>
        <li>클라우드 사업자의 물리적 및 기술적 보안조치(접근통제, 백업, 암호화 저장)를 이용합니다.</li>
      </ul>

      <h2>8. 쿠키의 사용</h2>
      <p>서비스는 로그인 상태를 유지하기 위한 세션 쿠키만 사용하며, 광고,행태정보 추적 쿠키는 사용하지 않습니다. 브라우저 설정에서 쿠키를 거부할 수 있으나, 그 경우 로그인이 필요한 기능을 이용할 수 없습니다.</p>

      <h2>9. 개인정보 보호책임자</h2>
      <div className="legal-table">
        <table>
          <tbody>
            <tr>
              <th>처리자</th>
              <td>주식회사 {BRAND.DEVELOPER}</td>
            </tr>
            <tr>
              <th>보호책임자</th>
              <td>[성명, 직책: 지정 예정]</td>
            </tr>
            <tr>
              <th>연락처</th>
              <td>[이메일: 확정 필요], [전화: 확정 필요]</td>
            </tr>
          </tbody>
        </table>
      </div>
      <p>개인정보 침해에 대한 신고나 상담이 필요하면 다음 기관에 문의할 수 있습니다.</p>
      <ul>
        <li>개인정보침해신고센터 (privacy.kisa.or.kr, 국번 없이 118)</li>
        <li>개인정보분쟁조정위원회 (kopico.go.kr, 1833-6972)</li>
        <li>대검찰청 사이버수사과 (spo.go.kr, 1301), 경찰청 사이버수사국 (ecrm.police.go.kr, 182)</li>
      </ul>

      <h2>10. 방침의 변경과 시행일</h2>
      <p>
        이 방침은 {EFFECTIVE}부터 시행합니다. 내용이 바뀌면 시행 7일 전부터 서비스 화면에 공지합니다. 서비스 이용 조건은 <Link to="/terms">이용약관</Link>에서 정합니다.
      </p>
    </LegalPage>
  );
}
